import { request } from './_core'

// ── Admin Stats ────────────────────────────────────────────────

export interface AdminActivityStat {
  activitySlug:   string
  totalCount:     number
  completedCount: number
  abandonedCount: number
  avgDurationMs:  number
}

export interface AdminCategoryStat {
  category: string
  count:    number
}

export interface AdminThemeStat {
  themeId: string
  count:   number
}

export interface AdminDifficultyStat {
  difficulty: string
  count:      number
}

export interface AdminStatsResponse {
  sessions: {
    total:             number
    completedThisWeek: number
    byActivity:        AdminActivityStat[]
    byCategory:        AdminCategoryStat[]
    byTheme:           AdminThemeStat[]
    byDifficulty:      AdminDifficultyStat[]
  }
  notebooks: {
    total: number
  }
  users: {
    total:          number
    activeThisWeek: number
    activeThisMonth: number
  }
}

export const adminStats = {
  stats: () => request<AdminStatsResponse>('/admin/stats'),
}
